// libs/shared/core/src/lib/pipes/registration-status.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import {
  RegistrationStatus,
  RegistrationStatusConfigs,
} from '../models/registration-status.model';

@Pipe({
  name: 'registrationStatus',
  standalone: true,
})
export class RegistrationStatusPipe implements PipeTransform {
  transform(status: RegistrationStatus | undefined): {
    status: string;
    type: (typeof RegistrationStatusConfigs)[RegistrationStatus]['type'];
    label: string;
    action: string;
    styles: (typeof RegistrationStatusConfigs)[RegistrationStatus]['styles'];
  } | null {
    if (!status) return null;
    const config = RegistrationStatusConfigs[status] || {
      type: 'info',
      label: status,
      action: '',
      styles: { background: '#E3F2FD', color: '#1565C0' },
    };

    return {
      status,
      ...config,
    };
  }
}
